import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'
import VsText from '@/components/vision/VsText.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientSearch',
  emits: ["update-search"],
  setup(__props, { emit }: { emit: ({
  (e: 'update-search', initialClientName: string)
}), expose: any, slots: any, attrs: any }) {

const search = ref('')



function updateSearch(newSearch: string) {
  search.value = newSearch

  emit('update-search', search.value)
}

return { __sfc: true,search, emit, updateSearch, VsTextInput, VsText }
}

})